module.exports = __webpack_public_path__ + "media/images/icon__burger-menu@2x-6b66b33b6f069a767b64ad0c116d4e13.png";